// lz: English sale dates, formatted for the selected market and visitor's local day.
(() => {
  if (customElements.get('sale-end-date-lz')) return;
  const parseDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return null;
    const [, year, month, day] = match.map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
  };
  class SaleEndDateLz extends HTMLElement {
    static get observedAttributes() { return ['data-manual', 'data-date', 'data-country']; }
    connectedCallback() { this.update(); }
    disconnectedCallback() { clearTimeout(this.timer); }
    attributeChangedCallback() { if (this.isConnected) this.update(); }
    update() {
      clearTimeout(this.timer);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const custom = this.dataset.manual === 'true' ? parseDate(this.dataset.date) : null;
      const date = custom && custom >= today ? custom : today;
      const country = this.dataset.country || 'US';
      let formatter;
      try { formatter = new Intl.DateTimeFormat(`en-${country}`, { month: 'short', day: 'numeric' }); }
      catch { formatter = new Intl.DateTimeFormat('en-GB', { month: 'short', day: 'numeric' }); }
      this.textContent = `Ends ${formatter.format(date)}: `;
      const nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      this.timer = setTimeout(() => this.update(), nextDay - now + 100);
    }
  }
  customElements.define('sale-end-date-lz', SaleEndDateLz);
  const refresh = () => document.querySelectorAll('sale-end-date-lz').forEach(element => element.update());
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
})();
